import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import "./App.css";
import BodyContent from "./component/BodyContent";
import Chatbot from "./component/Chatbot";
import Footer from "./component/Footer";
import NavBar from "./component/NavBar";
import Policy from "./component/Policy";
import Terms from "./component/Terms";
import ThankYouScreen from "./component/ThankYouScreen";

const App = () => {
  return (
    <Router>
      <MainApp />
    </Router>
  );
};

const MainApp = () => {
  const location = useLocation();

  return (
    <>
      <NavBar />
      <Routes>
        <Route path="/" element={<BodyContent />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/thank-you" element={<ThankYouScreen />} />
      </Routes>
      {location.pathname !== "/thank-you" && <Footer />}
      <Chatbot />
    </>
  );
};
export default App;
